import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

const setInnerPagesCountReducer = (state: DesignState, action: PayloadAction<number | undefined>) => {
  state.innerPagesCount = action.payload;
};

export default setInnerPagesCountReducer;
